import gql from 'graphql-tag';

export const updateOfferByAdmin = gql`
  mutation updateOfferByAdmin($input: UpdateOfferInput){
    updateOfferByAdmin(input: $input){
      id
    }
  }
`;
